module.exports = __webpack_public_path__ + "img/circle-loader.e627326d.svg";